export var mulheresSubTabs = [
    { key: "visao-geral", label: "Visão Geral" },
    { key: "feminicidios", label: "Feminicídios" },
    { key: "perfil-vitimas", label: "Perfil das Vítimas" },
    { key: "tempo-territorio", label: "Tempo e Território" },
    { key: "bos-deams", label: "BOs e DEAMs" },
];
export var MULHERES_TERRITORIAL_COVERAGE = [
    {
        territorio: "Planície Litorânea",
        municipios: [
            "Bom Princípio do Piauí",
            "Buriti dos Lopes",
            "Cajueiro da Praia",
            "Caraúbas do Piauí",
            "Caxingó",
            "Cocal",
            "Cocal do Alves",
            "Ilha Grande",
            "Luís Correia",
            "Murici dos Portelas",
            "Parnaíba",
        ],
    },
    {
        territorio: "Cocais",
        municipios: [
            "Barras",
            "Batalha",
            "Brasileira",
            "Campo Largo do Piauí",
            "Domingos Mourão",
            "Esperantina",
            "Joaquim Pires",
            "Joca Marques",
            "Lagoa de São Francisco",
            "Luzilândia",
            "Madeiro",
            "Matias Olímpio",
            "Milton Brandão",
            "Morro do Chapéu do Piauí",
            "Nossa Senhora dos Remédios",
            "Pedro II",
            "Piracuruca",
            "Piripiri",
            "Porto",
            "São João da Fronteira",
            "São João do Arraial",
            "São José do Divino",
        ],
    },
    {
        territorio: "Carnaubais",
        municipios: [
            "Assunção do Piauí",
            "Boa Hora",
            "Boqueirão do Piauí",
            "Buriti dos Montes",
            "Cabeceiras do Piauí",
            "Campo Maior",
            "Capitão de Campos",
            "Castelo do Piauí",
            "Cocal de Telha",
            "Jatobá do Piauí",
            "Juazeiro do Piauí",
            "Nossa Senhora de Nazaré",
            "Novo Santo Antônio",
            "São João da Serra",
            "São Miguel do Tapuio",
            "Sigefredo Pacheco",
        ],
    },
    {
        territorio: "Entre Rios",
        municipios: [
            "Agricolândia",
            "Água Branca",
            "Alto Longá",
            "Altos",
            "Amarante",
            "Angical do Piauí",
            "Barro Duro",
            "Beneditinos",
            "Coivaras",
            "Curralinhos",
            "Demerval Lobão",
            "Hugo Napoleão",
            "Jardim do Mulato",
            "José de Freitas",
            "Lagoa Alegre",
            "Lagoa do Piauí",
            "Lagoinha do Piauí",
            "Miguel Alves",
            "Miguel Leão",
            "Monsenhor Gil",
            "Nazária",
            "Olho d'Água do Piauí",
            "Palmeirais",
            "Passagem Franca do Piauí",
            "Pau d'Arco do Piauí",
            "Regeneração",
            "Santo Antônio dos Milagres",
            "São Gonçalo do Piauí",
            "São Pedro do Piauí",
            "Teresina",
            "União",
        ],
    },
    {
        territorio: "Vale do Sambito",
        municipios: [
            "Aroazes",
            "Barra d'Alcântara",
            "Elesbão Veloso",
            "Francinópolis",
            "Inhuma",
            "Ipiranga do Piauí",
            "Lagoa do Sítio",
            "Novo Oriente do Piauí",
            "Pimenteiras",
            "Prata do Piauí",
            "Santa Cruz dos Milagres",
            "São Félix do Piauí",
            "São Miguel da Baixa Grande",
            "Valença do Piauí",
            "Várzea Grande",
        ],
    },
    {
        territorio: "Vale do Rio Guaribas",
        municipios: [
            "Alagoinha do Piauí",
            "Alegrete do Piauí",
            "Aroeiras do Itaim",
            "Bocaina",
            "Campo Grande do Piauí",
            "Dom Expedito Lopes",
            "Francisco Santos",
            "Fronteiras",
            "Geminiano",
            "Itainópolis",
            "Monsenhor Hipólito",
            "Paquetá",
            "Picos",
            "Pio IX",
            "Santana do Piauí",
            "Santo Antônio de Lisboa",
            "São João da Canabrava",
            "São José do Piauí",
            "São Julião",
            "São Luís do Piauí",
            "Sussuapara",
            "Vera Mendes",
            "Vila Nova do Piauí",
        ],
    },
    {
        territorio: "Chapada Vale do Rio Itaim",
        municipios: [
            "Acauã",
            "Belém do Piauí",
            "Betânia do Piauí",
            "Caldeirão Grande do Piauí",
            "Caridade do Piauí",
            "Curral Novo do Piauí",
            "Francisco Macedo",
            "Jacobina do Piauí",
            "Jaicós",
            "Marcolândia",
            "Massapê do Piauí",
            "Padre Marcos",
            "Patos do Piauí",
            "Paulistana",
            "Queimada Nova",
            "Simões",
        ],
    },
    {
        territorio: "Vale do Canindé",
        municipios: [
            "Bela Vista do Piauí",
            "Cajazeiras do Piauí",
            "Campinas do Piauí",
            "Colônia do Piauí",
            "Conceição do Canindé",
            "Floresta do Piauí",
            "Isaías Coelho",
            "Oeiras",
            "Santa Cruz do Piauí",
            "Santa Rosa do Piauí",
            "Santo Inácio do Piauí",
            "São Francisco de Assis do Piauí",
            "São Francisco do Piauí",
            "São João da Varjota",
            "Simplício Mendes",
            "Tanque do Piauí",
            "Wall Ferraz",
        ],
    },
    {
        territorio: "Serra da Capivara",
        municipios: [
            "Anísio de Abreu",
            "Bonfim do Piauí",
            "Campo Alegre do Fidalgo",
            "Capitão Gervásio Oliveira",
            "Caracol",
            "Coronel José Dias",
            "Dirceu Arcoverde",
            "Dom Inocêncio",
            "Fartura do Piauí",
            "Guaribas",
            "João Costa",
            "Jurema",
            "Lagoa do Barro do Piauí",
            "São Braz do Piauí",
            "São João do Piauí",
            "São Lourenço do Piauí",
            "São Raimundo Nonato",
            "Várzea Branca",
        ],
    },
    {
        territorio: "Vale dos Rios Piauí e Itaueiras",
        municipios: [
            "Arraial",
            "Brejo do Piauí",
            "Canto do Buriti",
            "Flores do Piauí",
            "Floriano",
            "Francisco Ayres",
            "Itaueira",
            "Nazaré do Piauí",
            "Nova Santa Rita",
            "Paes Landim",
            "Pajeú do Piauí",
            "Pavussu",
            "Pedro Laurentino",
            "Ribeira do Piauí",
            "Rio Grande do Piauí",
            "São José do Peixe",
            "São Miguel do Fidalgo",
            "Socorro do Piauí",
            "Tamboril do Piauí",
        ],
    },
    {
        territorio: "Tabuleiros do Alto Parnaíba",
        municipios: [
            "Antônio Almeida",
            "Baixa Grande do Ribeiro",
            "Bertolínia",
            "Canavieira",
            "Guadalupe",
            "Jerumenha",
            "Landri Sales",
            "Marcos Parente",
            "Porto Alegre do Piauí",
            "Ribeiro Gonçalves",
            "Sebastião Leal",
            "Uruçuí",
        ],
    },
    {
        territorio: "Chapada das Mangabeiras",
        municipios: [
            "Alvorada do Gurguéia",
            "Avelino Lopes",
            "Barreiras do Piauí",
            "Bom Jesus",
            "Colônia do Gurguéia",
            "Corrente",
            "Cristalândia do Piauí",
            "Cristino Castro",
            "Curimatá",
            "Currais",
            "Eliseu Martins",
            "Gilbués",
            "Júlio Borges",
            "Manoel Emídio",
            "Monte Alegre do Piauí",
            "Morro Cabeça no Tempo",
            "Palmeira do Piauí",
            "Parnaguá",
            "Redenção do Gurguéia",
            "Riacho Frio",
            "Santa Filomena",
            "Santa Luz",
            "São Gonçalo do Gurguéia",
            "Sebastião Barros",
        ],
    },
];
export var MULHERES_TERRITORIAL_COVERAGE_BY_TERRITORIO = MULHERES_TERRITORIAL_COVERAGE.reduce(function (acc, item) {
    acc[item.territorio] = item.municipios;
    return acc;
}, {});
export var MULHERES_BOS_DEAMS_DELEGACIAS = [
    "1ª DEAM (Centro)",
    "2ª DEAM (Norte)",
    "3ª DEAM (Sul)",
    "4ª DEAM (Sudeste)",
    "Casa Da Mulher Brasileira",
    "Plantão da Casa da Mulher Brasileira",
    "Diretoria de Proteção à Mulher e aos Grupos Vulneráveis",
    "DEAM - Água Branca",
    "DEAM - Barras",
    "DEAM - Bom Jesus",
    "DEAM - Campo Maior",
    "DEAM - Canto Do Buriti",
    "DEAM - Corrente",
    "DEAM - Esperantina",
    "DEAM - Floriano",
    "DEAM - Luís Correia",
    "DEAM - Oeiras",
    "DEAM - Paulistana",
    "DEAM - Parnaíba",
    "DEAM - Picos",
    "DEAM - Piripiri",
    "DEAM - São Raimundo Nonato",
    "DEAM - Uruçuí",
    "DEAM - Valença",
];
export var MULHERES_BOS_DEAMS_MUNICIPIO_BY_DELEGACIA = {
    "1ª DEAM (Centro)": "Teresina",
    "2ª DEAM (Norte)": "Teresina",
    "3ª DEAM (Sul)": "Teresina",
    "4ª DEAM (Sudeste)": "Teresina",
    "Casa Da Mulher Brasileira": "Teresina",
    "Plantão da Casa da Mulher Brasileira": "Teresina",
    "Diretoria de Proteção à Mulher e aos Grupos Vulneráveis": "Teresina",
    "DEAM - Água Branca": "Água Branca",
    "DEAM - Barras": "Barras",
    "DEAM - Bom Jesus": "Bom Jesus",
    "DEAM - Campo Maior": "Campo Maior",
    "DEAM - Canto Do Buriti": "Canto Do Buriti",
    "DEAM - Corrente": "Corrente",
    "DEAM - Esperantina": "Esperantina",
    "DEAM - Floriano": "Floriano",
    "DEAM - Luís Correia": "Luís Correia",
    "DEAM - Oeiras": "Oeiras",
    "DEAM - Paulistana": "Paulistana",
    "DEAM - Parnaíba": "Parnaíba",
    "DEAM - Picos": "Picos",
    "DEAM - Piripiri": "Piripiri",
    "DEAM - São Raimundo Nonato": "São Raimundo Nonato",
    "DEAM - Uruçuí": "Uruçuí",
    "DEAM - Valença": "Valença do Piauí",
};
export var MULHERES_BOS_DEAMS_TERRITORIO_BY_DELEGACIA = {
    "1ª DEAM (Centro)": "Entre Rios",
    "2ª DEAM (Norte)": "Entre Rios",
    "3ª DEAM (Sul)": "Entre Rios",
    "4ª DEAM (Sudeste)": "Entre Rios",
    "Casa Da Mulher Brasileira": "Entre Rios",
    "Plantão da Casa da Mulher Brasileira": "Entre Rios",
    "Diretoria de Proteção à Mulher e aos Grupos Vulneráveis": "Entre Rios",
    "DEAM - Água Branca": "Entre Rios",
    "DEAM - Barras": "Cocais",
    "DEAM - Bom Jesus": "Chapada das Mangabeiras",
    "DEAM - Campo Maior": "Carnaubais",
    "DEAM - Canto Do Buriti": "Vale dos Rios Piauí e Itaueiras",
    "DEAM - Corrente": "Chapada das Mangabeiras",
    "DEAM - Esperantina": "Cocais",
    "DEAM - Floriano": "Vale dos Rios Piauí e Itaueiras",
    "DEAM - Luís Correia": "Planície Litorânea",
    "DEAM - Oeiras": "Vale do Canindé",
    "DEAM - Paulistana": "Chapada Vale do Rio Itaim",
    "DEAM - Parnaíba": "Planície Litorânea",
    "DEAM - Picos": "Vale do Rio Guaribas",
    "DEAM - Piripiri": "Cocais",
    "DEAM - São Raimundo Nonato": "Serra da Capivara",
    "DEAM - Uruçuí": "Tabuleiros do Alto Parnaíba",
    "DEAM - Valença": "Vale do Sambito",
};
export var MULHERES_BOS_DEAMS_TERRITORIOS = Array.from(new Set(Object.values(MULHERES_BOS_DEAMS_TERRITORIO_BY_DELEGACIA)));
export var MULHERES_BOS_DEAMS_DELEGACIAS_BY_TERRITORIO = MULHERES_BOS_DEAMS_TERRITORIOS.reduce(function (acc, territorio) {
    acc[territorio] = MULHERES_BOS_DEAMS_DELEGACIAS.filter(function (delegacia) {
        return MULHERES_BOS_DEAMS_TERRITORIO_BY_DELEGACIA[delegacia] === territorio;
    });
    return acc;
}, {});
